module.exports = __webpack_public_path__ + "static/media/icn_file_itr.a8b21227.svg";